import Svg, { ClipPath, Defs, G, Path } from 'react-native-svg';
import { IllustrationProps } from '../Illustration';

export const Placeholder = ({ width = '100%', height = '100%', ref, testID }: IllustrationProps) => {
  return (
    <Svg width={width} height={height} ref={ref} testID={testID} viewBox="0 0 100 100" fill="none">
      <Path fill="#EEE" d="M0 0H100V100H0z" />
      <G clipPath="url(#clip0_3397_2495)">
        <Path
          d="M58 41a2 2 0 011.995 1.85L60 43v14a2 2 0 01-1.85 1.995L58 59H42a2 2 0 01-1.995-1.85L40 57V43a2 2 0 011.85-1.995L42 41h16zm-10.121 9.05l-5.657 5.657a1 1 0 01-.222.168V57h16v-1.125a1 1 0 01-.222-.168L54.95 52.88l-.707.707.207.207a1 1 0 01-1.415 1.414L47.88 50.05h-.001zM58 43H42v10.1l4.995-4.994a1.25 1.25 0 011.666-.091l.101.09 4.066 4.067 1.238-1.238a1.25 1.25 0 011.666-.091l.102.091L58 53.101V43zm-4.5 2a1.5 1.5 0 110 3 1.5 1.5 0 010-3z"
          fill="#8F8F8F"
        />
      </G>
      <Defs>
        <ClipPath id="clip0_3397_2495">
          <Path fill="#fff" transform="translate(38 38)" d="M0 0H24V24H0z" />
        </ClipPath>
      </Defs>
    </Svg>
  );
};
